import type { Announcement, DocumentItem, NewsItem } from '../types/content'

export const school = {
  name: 'TRƯỜNG THCS LÝ THƯỜNG KIỆT',
  shortName: 'THCS Lý Thường Kiệt',
  slogan: 'Đoàn kết - Tự tin - Sáng tạo - Phát triển',
  address: 'Phường Quảng Phú, TP. Đà Nẵng',
  phone: '0236 3821 234',
  email: 'thcslythuongkiet@danang.edu.vn',
  website: 'https://thcslythuongkiet.danang.edu.vn',
  founded: '2011',
  principal: 'Thầy Nguyễn Đức Minh',
}

export const news: NewsItem[] = [
  {
    id: '1',
    slug: 'le-khai-giang-nam-hoc-2024-2025',
    title: 'Lễ khai giảng năm học 2024 - 2025',
    excerpt:
      'Sáng ngày 05/09/2024, hòa chung không khí tưng bừng của ngày hội toàn dân đưa trẻ đến trường, Trường THCS Lý Thường Kiệt đã long trọng tổ chức lễ khai giảng năm học mới.',
    category: 'Tin tức nhà trường',
    image: '/assets/images/news-opening.jpg',
    date: '05/09/2024',
    views: 1256,
    featured: true,
    content: [
      'Sáng ngày 05/09/2024, hòa chung không khí tưng bừng của ngày hội toàn dân đưa trẻ đến trường, Trường THCS Lý Thường Kiệt đã long trọng tổ chức Lễ khai giảng năm học mới 2024 - 2025.',
      'Tham dự buổi lễ có đại diện lãnh đạo Phòng Giáo dục và Đào tạo TP. Tam Kỳ, chính quyền địa phương, Ban đại diện cha mẹ học sinh cùng toàn thể cán bộ, giáo viên và học sinh nhà trường.',
      'Trong không khí trang nghiêm và đầy hứng khởi, thầy Nguyễn Đức Minh - Hiệu trưởng nhà trường đã đọc thư của Chủ tịch nước gửi ngành giáo dục nhân dịp khai giảng năm học mới và đánh trống khai trường.',
      'Năm học mới, tập thể thầy và trò Trường THCS Lý Thường Kiệt tiếp tục phát huy truyền thống đoàn kết, nỗ lực thi đua dạy tốt - học tốt, xây dựng môi trường giáo dục an toàn, thân thiện, hiện đại và hội nhập.',
    ],
  },
  {
    id: '2',
    slug: 'ngoai-khoa-ky-nang-song-cho-hoc-sinh',
    title: 'Ngoại khóa: Kỹ năng sống cho học sinh',
    excerpt:
      'Buổi ngoại khóa trang bị cho học sinh những kỹ năng cần thiết trong cuộc sống, giúp các em tự tin và phát triển toàn diện.',
    category: 'Hoạt động đoàn đội',
    image: '/assets/images/news-life-skills.jpg',
    date: '28/08/2024',
    views: 892,
  },
  {
    id: '3',
    slug: 'hoc-sinh-dat-giai-cao-tai-ky-thi-hoc-sinh-gioi',
    title: 'Học sinh đạt giải cao tại kỳ thi Học sinh giỏi cấp thành phố',
    excerpt:
      'Trường THCS Lý Thường Kiệt đạt nhiều thành tích xuất sắc tại kỳ thi Học sinh giỏi cấp thành phố năm học 2023 - 2024.',
    category: 'Hoạt động chuyên môn',
    image: '/assets/images/news-award.jpg',
    date: '20/08/2024',
    views: 1102,
  },
  {
    id: '4',
    slug: 'phong-trao-ke-hoach-nho-dot-1-nam-2024',
    title: 'Phong trào “Kế hoạch nhỏ” đợt 1 năm 2024',
    excerpt:
      'Liên đội phát động phong trào “Kế hoạch nhỏ” đợt 1, thu hút sự tham gia tích cực của toàn thể học sinh.',
    category: 'Hoạt động đoàn đội',
    image: '/assets/images/news-piggy-bank.jpg',
    date: '15/08/2024',
    views: 756,
  },
  {
    id: '5',
    slug: 'chuong-trinh-tiep-suc-den-truong-nam-2024',
    title: 'Chương trình “Tiếp sức đến trường” năm 2024',
    excerpt:
      'Nhà trường phối hợp cùng các mạnh thường quân trao tặng quà và học bổng cho các em học sinh có hoàn cảnh khó khăn.',
    category: 'Tin tức nhà trường',
    image: '/assets/images/activity-art.jpg',
    date: '10/08/2024',
    views: 623,
  },
  {
    id: '6',
    slug: 'giai-bong-da-hoc-sinh-nam-hoc-2023-2024',
    title: 'Giải bóng đá học sinh năm học 2023 - 2024',
    excerpt:
      'Giải đấu diễn ra sôi nổi, đoàn kết, góp phần rèn luyện thể chất và tinh thần thể thao cho học sinh toàn trường.',
    category: 'Hoạt động đoàn đội',
    image: '/assets/images/activity-football.jpg',
    date: '30/07/2024',
    views: 845,
  },
]

export const announcements: Announcement[] = [
  { id: 'a1', title: 'Thông báo về việc nghỉ hè năm 2024', date: '01/06/2024' },
  { id: 'a2', title: 'Thông báo tuyển sinh lớp 6 năm học 2024 - 2025', date: '20/05/2024', important: true },
  { id: 'a3', title: 'Kế hoạch kiểm tra cuối học kỳ II năm học 2023 - 2024', date: '15/05/2024' },
  { id: 'a4', title: 'Thông báo về việc thu các khoản đầu năm học', date: '30/05/2024' },
  { id: 'a5', title: 'Thực đơn bán trú tuần 27', date: '26/04/2024' },
]

export const documents: DocumentItem[] = [
  { id: 'd1', code: 'KH-TS-2024', title: 'Kế hoạch tuyển sinh lớp 6 năm học 2024 - 2025', type: 'PDF', issuedAt: '03/06/2024', size: '1.2 MB' },
  { id: 'd2', code: 'QĐ-HT-2024', title: 'Quyết định thành lập Hội đồng tuyển sinh 2024', type: 'PDF', issuedAt: '03/06/2024', size: '850 KB' },
  { id: 'd3', code: 'TB-HĐSP-2024', title: 'Thông báo nghị quyết cuộc họp Hội đồng sư phạm', type: 'PDF', issuedAt: '01/06/2024', size: '640 KB' },
  { id: 'd4', code: 'KH-ÔN-2024', title: 'Kế hoạch ôn tập hè cho học sinh 2024', type: 'DOCX', issuedAt: '30/05/2024', size: '430 KB' },
  { id: 'd5', code: 'QC-TS-2024', title: 'Quy chế tuyển sinh vào lớp 6 năm 2024', type: 'PDF', issuedAt: '28/05/2024', size: '1.5 MB' },
]

export const workSchedule = [
  { time: '07:30', title: 'Họp giao ban Ban giám hiệu', location: 'Phòng họp 1' },
  { time: '14:00', title: 'Dự giờ thăm lớp Khối 7', location: 'Phòng học 7A' },
  { time: '15:30', title: 'Họp tổ chuyên môn', location: 'Phòng họp 2' },
]

export const activities = [
  { title: 'Hoạt động trải nghiệm “Hành trình về nguồn”', image: '/assets/images/activity-experience.jpg' },
  { title: 'Ngày hội đọc sách năm học 2023 - 2024', image: '/assets/images/activity-reading.jpg' },
  { title: 'Giải bóng đá học sinh năm học 2023 - 2024', image: '/assets/images/activity-football.jpg' },
  { title: 'Chương trình “Xuân yêu thương”', image: '/assets/images/activity-art.jpg' },
  { title: 'Hội thi “Tài năng học sinh”', image: '/assets/images/activity-talent.jpg' },
]
